// src/node_modules/@awesome.me/kit-63db24046b/icons/modules/kit/custom.mjs
var faGoogleCloud = {
  prefix: "fak",
  iconName: "google-cloud",
  icon: [
    512,
    512,
    [],
    "e00c",
    "M340.5 163.6l44.5-44.5 3-18.7c-81.1-73.7-210-65.4-283.1 17.4-20.3 23-35.4 51.7-43.4 81.3l15.9-2.2 89-14.7 6.9-7c39.6-43.5 106.5-49.3 152.3-12.3l15 .8zm107.9 34.2c-10.2-37.7-31.2-71.5-60.4-97.4l-62.5 62.5c26.4 21.6 41.4 54 40.8 88.1l0 11.1c30.7 0 55.6 24.9 55.6 55.6s-24.9 55-55.6 55l-111.3 0-10.9 11.9 0 66.7 10.9 10.5 111.3 0c79.9 .6 145.1-63 145.7-142.8 .4-48.4-23.5-93.8-63.6-120.9zM143.7 461.6l111.2 0 0-89-111.2 0c-7.9 0-15.6-1.7-22.8-5l-15.8 4.8-44.8 44.5-3.9 15.1c25.1 19 55.8 29.6 87.3 29.5zm0-288.7C63.9 173.3-.5 238.5 0 318.3 .3 362.9 21.1 404.9 56.4 432.1l64.5-64.5C93 354.9 80.5 322 93.2 294s45.6-40.4 73.5-27.8c12.3 5.6 22.2 15.4 27.8 27.8L259 229.5c-27.4-35.9-70.1-56.8-115.2-56.7z"
  ]
};
export {
  faGoogleCloud
};
